var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 44,
    viewBox: "0 0 50 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.125C0 1.39912 1.39912 0 3.125 0H46.875C48.6009 0 50 1.39912 50 3.125C50 4.85087 48.6009 6.25 46.875 6.25H3.125C1.39912 6.25 0 4.85087 0 3.125Z",
    fill: "#C9C9C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.625C0 38.8991 1.39912 37.5 3.125 37.5H46.875C48.6009 37.5 50 38.8991 50 40.625C50 42.3509 48.6009 43.75 46.875 43.75H3.125C1.39912 43.75 0 42.3509 0 40.625Z",
    fill: "#C9C9C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 18.75C1.39912 18.75 0 20.1491 0 21.875C0 23.6009 1.39912 25 3.125 25H28.125C29.8509 25 31.25 23.6009 31.25 21.875C31.25 20.1491 29.8509 18.75 28.125 18.75H3.125Z",
    fill: "#C9C9C9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.a365bd6ec95ad5212bd65a0f9c304450.svg";
export { ForwardRef as ReactComponent };